import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: "random",
  questionnaireStarted: false,
};

export const questionnaireStartedSlice = createSlice({
  name: "questionnaireStartedSlice",
  initialState,
  reducers: {
    setQuestionnaireStarted: (state, action) => {
      state.guid = "radnom";
      state.questionnaireStarted = true;
    },
    setQuestionnaireFinished: (state, action) => {
      state.guid = "radnom";
      state.questionnaireStarted = false;
    },
  },
});

export const { setQuestionnaireStarted, setQuestionnaireFinished } =
  questionnaireStartedSlice.actions;

export const questionnaireStartedReducer = questionnaireStartedSlice.reducer;
